import { useEffect, useState } from 'react';
import useAxios from '../../../../hooks/useAxios';
import Constants from '../../../../Constants';
import BarChart from './BarChart';
import XLoader from '../../../../components/common/XLoader';
import { DATE_INTERVAL } from '@demandproai/shared';
import CardHeader from "../../../superAdmin/components/common/CardHeader";
import { useCompanyFilterContext } from '../../../superAdmin/components/context/CompanyFilterContext';
import { pieCardClasses, pieContentClasses } from '../../../../components/common/dashboardClasses';
import { costTotalTextClasses, costAmountClasses } from '../../../../components/common/dashboardGridClasses';

const CaseCountGraph = () => {
  const { filterParams } = useCompanyFilterContext();
  const { selectedRange, selectedCompanies: companyIds, selectedStatus: companyStatus, selectedTiers: tier } = filterParams;

  const [chartData, setChartData] = useState([]);
  const [interval, setInterval] = useState(DATE_INTERVAL.MONTHLY);
  const [totalCases, setTotalCases] = useState(0);
  const { postData, isLoading } = useAxios();

  useEffect(() => {
    const fetchCaseCountGraph = async () => {
      if (!selectedRange?.startDate || !selectedRange?.endDate) {
        console.warn('selectedRange with startDate and endDate is required for CaseCountGraph');
        return;
      }

      console.log('Fetching case count graph - effect triggered');

      const payload = {
        companyIds,
        startDate: selectedRange.startDate.toISOString(),
        endDate: selectedRange.endDate.toISOString(),
        ...(companyStatus && companyStatus.length > 0 && { companyStatus: companyStatus }),
        ...(tier && tier.length > 0 && { tier })
      };

      const { success, data } = await postData(
        Constants.ApiUrl.super.dashboard.caseCountGraph,
        payload
      );

      if (success) {
        setChartData(data.data || []);
        setInterval(data.interval || DATE_INTERVAL.MONTHLY);
        setTotalCases(data.totalCases || 0);
      }
    };

    fetchCaseCountGraph();
  }, [
    JSON.stringify(companyIds),
    JSON.stringify(companyStatus),
    JSON.stringify(tier),
    selectedRange?.startDate?.toISOString(),
    selectedRange?.endDate?.toISOString()
  ]);

  const rightSection = (
    <div className={costTotalTextClasses}>
      <span className={`${costAmountClasses} ml-2`}>
        Total: {totalCases} cases ({interval})
      </span>
    </div>
  );

  return (
    <div className={pieCardClasses}>
      <CardHeader
        title="Monthly Case Volume"
        rightContent={rightSection}
      />

      <div className={`${pieContentClasses} text-center`}>
        {isLoading ? (
          <XLoader />
        ) : (
          <BarChart dataPoints={chartData} width={400} height={240} />
        )}
      </div>
    </div>
  );
};

export default CaseCountGraph;
